export const YesNoItems = {
  false: "Nie",
  true: "Tak"
}